import React from "react";
import Template from "../../../components/Dashboard/Template";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import { Typography } from "@mui/material";
import appcolors from "../../../constants/Colors";

const headerData = [
  {
    id: 1,
    label: "Service",
  },
  {
    id: 2,
    label: "Total Earnings",
  },
  {
    id: 3,
    label: "This Month",
  },
  {
    id: 4,
    label: "Branch Name",
  },
];

const displayRows = ["service", "totalEarnings", "thisMonth", "assingedBranch"];

function TopServicesTable({ data }) {
  return (
    <Template primaryHeading={"Top Services"} secondaryHeading={"Hit List"}>
      {data?.length > 0 ? (
        <DashboardTable
          showHeader={true}
          headerData={headerData}
          tableData={data}
          diplayRows={displayRows}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
        >
          No Service Found!
        </Typography>
      )}
    </Template>
  );
}

export default TopServicesTable;
